<ngx-datatable
  #partFeaturesTable
  *ngIf="!rerender && currentPartGraphics"
  id="part-features-{{ tabIndex }}"
  class="material"
  [rows]="currentPartGraphics"
  [loadingIndicator]="loadingIndicator"
  [cssClasses]="tableSettings?.cssClasses"
  [columnMode]="tableSettings?.columnMode"
  [reorderable]="tableSettings?.reorderable"
  [headerHeight]="tableSettings?.headerHeight"
  [footerHeight]="tableSettings?.footerHeight"
  [limit]="100"
  [messages]="tableMessageOptions"
>
  <ngx-datatable-column
    *ngFor="let col of columnDefinition; trackBy: trackByProp"
    [name]="col.name"
    [prop]="col.prop"
    [sortable]="false"
    [canAutoResize]="true"
    [draggable]="false"
    [resizeable]="true"
    [headerCheckboxable]="false"
    [checkboxable]="false"
    [width]="col.width"
  >
    <ng-template ngx-datatable-cell-template let-value="value" let-row="row" let-rowIndex="rowIndex">
      <span class="cell">
        <span *ngIf="col.float; else plain">
          {{ value | floatCalcFixDecimal:col.float:false }}
        </span>

        <ng-template #plain>
          {{ value }}
        </ng-template>
      </span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template let-rowCount="rowCount">
      <div class="dt-footer-grid" [style.gridTemplateColumns]="footerGridColumns">

        <!-- Eine Footer-Zelle pro Spalte -->
        <div
          class="dt-footer-cell"
          *ngFor="let col of columnDefinition; let i = index; trackBy: trackByProp"
        >
          <!-- Links: Total in erster Spalte (oder wo du willst) -->
          <ng-container *ngIf="i === 0">
            {{ 'JSON_CONFIG.DETAIL_VIEW.TOTAL' | translate }}: {{ rowCount }}
          </ng-container>

          <!-- Summe unter "Fläche" -->
          <ng-container *ngIf="i === sumIndexFlaeche">
          <span class="dt-sum">
            &sum; = {{ summeFlaechenAusgleichen | floatCalcFixDecimal:1:false }}
          </span>
          </ng-container>

          <!-- Summe unter "GIS-Fläche" -->
          <ng-container *ngIf="i === sumIndexGis">
          <span class="dt-sum">
            &sum; = {{ summeFlaecheBerechnet | floatCalcFixDecimal:1:false }}
          </span>
          </ng-container>
        </div>

      </div>
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>
